import React, { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import NumberFormat from 'react-number-format';
import styles from './styles.module.scss';

import apiCartpage from '../../../api/Cart';
import apiProduct from '../../../api/Product';
import ApiCart from '../../../api/Cart/CartApiFL';
import { getCart } from '../../../redux/actions/cartActions';

import LinkLang from '../../Wraps/LinkLang';
import Quantity from '../Quantity';
import { ReactComponent as DeleteIcon } from '../../../assets/icons/icon-delete.svg';

import Config, { spanish } from '../../../config/config';

const Item = ({
  item,
  onRemove,
  onAdd,
  updateCartItem,
  onChangeProductQuantity,
}) => {
  const [itemQuantity, setItemQuantity] = useState(item.Cantidad);
  const [info, setInfo] = useState(null);
  const sku = parseFloat(item?.idProducto);
  useEffect(async () => {
    setInfo(await apiProduct.getSKU(sku));
  }, [sku]);
  const isReady = info && info[0] && info[0]?.SLUG;
  return (
    <div className={styles.item}>
      <div className={styles.itemTitle}>
        {isReady && (
          <LinkLang
            to={`/product/${info[0]?.SLUG}`}
            state={{ sku: item?.idProducto }}
          >
            <p>{info[0]?.Name}</p>
            <p className={styles.itemSku}>
              {spanish
                ? `Producto #${item.idProducto}`
                : `Product #${item.idProducto}`}
            </p>
          </LinkLang>
        )}
      </div>
      <div className={styles.itemImage}>
        {isReady && (
          <LinkLang
            to={`/product/${info[0]?.SLUG}`}
            state={{ sku: item?.idProducto }}
          >
            <img
              src={
                Config.cdn.cdn_path +
                info[0].imagesProduct[0].formats.thumbnail.url
              }
              alt={info[0?.Name]}
            />
          </LinkLang>
        )}
      </div>
      <div className={styles.itemPrice}>
        <p>
          <NumberFormat
            value={item?.PrecioUnitario}
            thousandSeparator
            prefix="$"
            suffix=" MXN"
            displayType="text"
          />
        </p>
      </div>
      <div className={styles.itemQuantity}>
        <Quantity
          number={itemQuantity}
          onRemove={() => onRemove(item.Cantidad, item.idProducto)}
          onAdd={() => onAdd(item.Cantidad, item.idProducto)}
          onChange={(e) =>
            onChangeProductQuantity(e, item.idProducto, setItemQuantity)
          }
        />
      </div>
      <div className={styles.itemTotal}>
        <p>
          <NumberFormat
            value={item?.Total}
            thousandSeparator
            prefix="$"
            suffix=" MXN"
            displayType="text"
          />
        </p>
      </div>
      <div className={styles.itemDelete}>
        <button
          type="button"
          onClick={() => updateCartItem(item.idProducto, 0)}
        >
          <DeleteIcon />
        </button>
      </div>
    </div>
  );
};

const Cart = () => {
  const [content, setContent] = useState(null);
  const dispatch = useDispatch();
  const cartProductSummary = useSelector(
    (globalState) => globalState.cartInfo.InfoCarrito
  );
  const IdEstado = useSelector(
    (globalState) => globalState.estadoSelection.selectedEstadoId
  );
  const isDisabled =
    cartProductSummary[0]?.DetalleCarrito === undefined ||
    cartProductSummary[0]?.DetalleCarrito?.length === 0;
  useEffect(async () => {
    setContent(await apiCartpage.getContent());
  }, []);

  const updateCartItem = async (productId, quantityToUpdate) => {
    const currentCartDetail = cartProductSummary[0].DetalleCarrito;
    const currentCartId = cartProductSummary[0].idCarrito;
    const filterProductToRemove = currentCartDetail.filter(
      (detail) => detail.idProducto === productId
    );

    const filterProductsToRemain = currentCartDetail.filter(
      (detail) => detail.idProducto !== productId
    );

    const mappedProductsToRemove = filterProductToRemove.map((product) => {
      const rObj = {};
      rObj.Cve_Prod = product.idProducto;
      rObj.Cantidad = quantityToUpdate;
      rObj.TipoUnidad = 'PI';
      return rObj;
    });

    const mappedProductsToRemain = filterProductsToRemain.map((product) => {
      const rObj = {};
      rObj.Cve_Prod = product.idProducto;
      rObj.Cantidad = product.Cantidad;
      rObj.TipoUnidad = 'PI';
      return rObj;
    });

    const finalCartProductArray = mappedProductsToRemain.concat(
      mappedProductsToRemove
    );

    const payload = {
      Cliente: Config.api_services.client,
      Pais: 'MEX',
      Ambiente: Config.api_services.environment,
      AgregarCarrito: {
        IdCarrito: currentCartId,
        IdEstado,
        TipoVenta: 1,
        FormaVenta: 3,
        IdFbo: 0,
        Productos: finalCartProductArray,
      },
    };

    const resp = await ApiCart.updateCart(payload);
    if (resp.Codigo === 200 || resp.Codigo === -1) {
      dispatch(getCart(resp.IdCarrito));
    }
  };

  const onRemove = (quantity, productId) => {
    const removeByOne = quantity - 1;
    updateCartItem(productId, removeByOne);
  };

  const onAdd = (quantity, productId) => {
    const addByOne = quantity + 1;
    updateCartItem(productId, addByOne);
  };

  const onChangeProductQuantity = (e, productId, setItemQuantity) => {
    setItemQuantity(e.target.value);
    if (e.target.value > 0) {
      updateCartItem(productId, e.target.value);
    }
  };

  return (
    <div className={styles.container}>
      <div className={styles.header}>
        <div className={styles.breadcrumb}>
          <p>
            {spanish
              ? content?.Breadcrumb1Spanish
              : content?.Breadcrumb1English}{' '}
            /{' '}
          </p>
          <b>
            {spanish
              ? content?.Breadcrumb2Spanish
              : content?.Breadcrumb2English}
          </b>
        </div>
        <div className={styles.title}>
          <h2>{spanish ? content?.TitleSpanish : content?.TitleEnglish}</h2>
        </div>
      </div>
      <div className={styles.rows}>
        <p>{spanish ? 'DESCRIPCIÓN' : 'DESCRIPTION'}</p>
        <p>{spanish ? 'PRECIO UNITARIO' : 'UNIT PRICE'}</p>
        <p>{spanish ? 'CANTIDAD' : 'QUANTITY'}</p>
        <p>TOTAL</p>
      </div>
      <div className={styles.summary}>
        {!isDisabled && (
          <div className={styles.list}>
            {cartProductSummary[0]?.DetalleCarrito.map((item) => (
              <Item
                item={item}
                key={item.idProductoCarrito}
                onRemove={onRemove}
                onAdd={onAdd}
                onChangeProductQuantity={onChangeProductQuantity}
                updateCartItem={updateCartItem}
              />
            ))}
          </div>
        )}
        <div className={styles.grandTotal}>
          <p>{spanish ? 'TOTAL DEL PEDIDO' : 'ORDER TOTAL'}</p>
          <p>
            <NumberFormat
              value={
                cartProductSummary[0]?.Total
                  ? cartProductSummary[0]?.Total
                  : '0'
              }
              thousandSeparator
              prefix="$"
              suffix=" MXN"
              displayType="text"
            />
          </p>
        </div>
      </div>
      <div className={styles.buttons}>
        <LinkLang to="/" className="btn btn-white">
          {spanish
            ? content?.BackToStoreButtonSpanish
            : content?.BackToStoreButtonEnglish}
        </LinkLang>
        <LinkLang
          to={isDisabled ? '/cart' : '/guest'}
          className={`btn btn-yellow ${isDisabled ? 'disabled' : ''}`}
        >
          {spanish
            ? content?.ContinueButtonSpanish
            : content?.ContinueButtonEnglish}
        </LinkLang>
      </div>
    </div>
  );
};

export default Cart;
